import { Image } from "react-native"
import { view_styles } from "../../constants/styles"
import { Icons } from "../../Components"
import type { EventProps, LeagueProps } from "../../types"
import moment from "moment-mini"
import React, { useState } from "react"
import { Button, Text, View } from "../../Components/Themed"
import { useColors } from "../../constants/useColors"

type EventCardProps = {
    league?:LeagueProps,
    hidden?:boolean,
    disable_collapse?:boolean,
    event:EventProps
}
const EventCard = ({ hidden, disable_collapse, event, league }:EventCardProps) => {
    const C = useColors();
    const [ expanded, setExpanded ] = useState(true);
    const overtime_occurred = event.event_scoring && event.event_scoring.length > 4 ? true : false;
    if(hidden){ return <></> }

    return (
        <View type='header' float style={{ minWidth:350, borderRadius:0 }}>
            <Button disabled={disable_collapse} transparent style={{ flexDirection:'row', alignItems:'center', borderRadius:0 }} onPress={() => setExpanded(!expanded)}>
                <View transparent style={{ flexDirection:'row', alignItems:'center', paddingRight:5, borderRightWidth:1, borderColor:C.borders.light }}>
                    {league ?
                    <Image
                        source={{ uri: league.league_image }}
                        style={{ height:30, width:30, borderRadius:4, marginRight:5 }}
                        resizeMode="cover"
                    />
                    :<></>}
                </View>
                <View transparent style={{ flex:1, marginLeft:5 }}>
                    <Text theme="h1">{event.away?.market_name} {event.away?.name} vs {event.home?.market_name} {event.home?.name}</Text>
                    <Text style={{ marginTop:3 }} theme="description">{event.time_detail == 'scheduled' ? moment(event.scheduled_datetime).format('MMM D - hh:mm a') : event.time_detail}</Text>
                </View>
                {!disable_collapse ?
                <Icons.ChevronIcon direction={expanded?'up':'down'} color={C.text.h1} size={8} />
                :<></>}
            </Button>
                {event.event_scoring && expanded ?
                <View transparent style={{ borderTopWidth:1, borderColor:C.borders.light, padding:10 }}>
                    <View transparent style={view_styles.body_row}>
                        <Image
                            source={{ uri: event.away?.image?.url }}
                            style={{ height:20, width:20, borderRadius:4, marginRight:5 }}
                            resizeMode="cover"
                        />
                        <Text style={{ flex:1 }} theme="description">{event.away?.abbr}</Text>
                        <View transparent style={{ flex:1, flexDirection:'row', alignItems:'center' }}>
                            {event.event_scoring.sort((a,b) => a.period - b.period).map(s => {
                                return (
                                    <View transparent style={{ flex:1 }}>
                                        <Text theme={overtime_occurred && s.period == 4 ? 'error': 'h2'}>{s.away_cumulative_score}</Text>
                                    </View>
                                )
                            })}
                        </View>
                    </View>
                    <View transparent style={view_styles.body_row}>
                        <Image
                            source={{ uri: event.home?.image?.url }}
                            style={{ height:20, width:20, borderRadius:4, marginRight:5 }}
                            resizeMode="cover"
                        />
                        <Text style={{ flex:1 }} theme="description">{event.home?.abbr}</Text>
                        <View transparent style={{ flex:1, flexDirection:'row', alignItems:'center' }}>
                            {event.event_scoring.map(s => {
                                return (
                                    <View transparent style={{ flex:1 }}>
                                        <Text theme={overtime_occurred && s.period == 4 ? 'error': 'h2'}>{s.home_cumulative_score}</Text>
                                    </View>
                                )
                            })}
                        </View>
                    </View>
                </View>
                :<></>}
            </View>
    )
}

export default EventCard